import React from "react";

import { getAllowedDeliveryTypes } from "@utils/deliveryMethod";
import { ProductVisibilityTypes } from "@utils/enums";
import { DeliveryTypes as DeliveryType } from "@utils/enums";

import DeliveryTypesComponent from "./deliveryTypes.component";

type DeliveryTypesProps = {
    productVisibilityType: ProductVisibilityTypes;
};

const DeliveryTypes = ({ productVisibilityType }: DeliveryTypesProps) => {
    const deliveryTypes = getAllowedDeliveryTypes(productVisibilityType);

    const allowClickAndCollect = deliveryTypes.includes(
        DeliveryType.ClickAndCollect,
    );
    const allowHomeDelivery = deliveryTypes.includes(DeliveryType.HomeDelivery);

    return (
        <DeliveryTypesComponent
            allowClickAndCollect={allowClickAndCollect}
            allowHomeDelivery={allowHomeDelivery}
        />
    );
};

export { DeliveryTypes };
